import { COMPANY_CONFIG } from '../config/companyConfig';

export const idValue = (value) => {
  if (!value) return '';
  if (typeof value === 'string') {
    const clean = value.trim();
    if (!clean) return '';
    return clean.includes('/') ? clean.split('/').filter(Boolean).pop() || '' : clean;
  }
  if (value.id) return String(value.id);
  if (value.path) return String(value.path).split('/').filter(Boolean).pop() || '';
  return '';
};

export const resolveTenantId = (source = {}) => (
  idValue(COMPANY_CONFIG.tenantId) ||
  idValue(source?.tenantId) ||
  idValue(source?.tenantIdValue) ||
  idValue(source?.tenant) ||
  idValue(source?.companyId) ||
  idValue(source?.companyIdValue) ||
  idValue(source?.company) ||
  idValue(source?.tenantRef) ||
  idValue(source?.companyRef) ||
  ''
);

export const resolveCompanyLogo = (settings = {}, userData = {}) => (
  settings?.general?.logoUrl ||
  settings?.general?.logo ||
  settings?.general?.companyLogo ||
  settings?.logoUrl ||
  settings?.logo ||
  settings?.companyLogo ||
  settings?.companyLogoUrl ||
  settings?.branding?.logoUrl ||
  settings?.branding?.logo ||
  userData?.logoUrl ||
  userData?.companyLogo ||
  userData?.companyLogoUrl ||
  userData?.tenantLogo ||
  ''
);
